<template>
  <div class="logins">
    <div class="dump-login" @click="tourist">
      跳过登陆
      <i class="el-icon-right"></i>
    </div>
    <img :src="require('@/assets/login/title.webp')" alt="platform_title" class="platform_title" />
    <div class="login" v-if="isLogin">
      <div class="user">
        <el-input
          placeholder="请输入注册手机号码"
          v-model="login.user"
          clearable
          prefix-icon="el-icon-user"
        ></el-input>
      </div>
      <div class="pas">
        <el-input
          placeholder="请输入密码"
          v-model="login.pas"
          prefix-icon="el-icon-lock"
          show-password
        ></el-input>
      </div>
      <div class="remeber">
        <el-checkbox v-model="login.checked">记住用户名和密码</el-checkbox>
        <span
          style="text-decoration: underline"
          @click=";(isLogin = false), (isReset = true)"
          >忘记密码？去找回</span
        >
      </div>
      <div class="submit">
        <button @click="loginClick">立即登录</button>
        <p style="text-decoration: underline" @click="toggle">
          没有账号？去注册
        </p>
      </div>
    </div>

    <div class="register" v-else-if="isReset">
      <div class="re-user">
        <el-input
          placeholder="请输入您的真实姓名"
          v-model="resetPassword.userName"
          clearable
          prefix-icon="el-icon-user"
        ></el-input>
      </div>
      <div class="re-idcard">
        <el-input
          placeholder="请输入您的身份证号"
          v-model="resetPassword.idCard"
          clearable
          prefix-icon="el-icon-postcard"
          @blur="LoseIdBlur(resetPassword.idCard)"
        ></el-input>
      </div>
      <div class="re-phone">
        <el-input
          placeholder="请请输入您的手机号"
          v-model="resetPassword.phone"
          clearable
          prefix-icon="el-icon-phone"
          @blur="LoseBlur(resetPassword.phone)"
        ></el-input>
      </div>
      <div class="re-pas">
        <el-input
          placeholder="请输入您的重置密码"
          v-model="resetPassword.rePas"
          clearable
          prefix-icon="el-icon-lock"
          show-password
        ></el-input>
      </div>
      <div class="re-pas">
        <el-input
          placeholder="再次输入您的重置密码"
          v-model="resetPassword.twoRePas"
          clearable
          prefix-icon="el-icon-lock"
          show-password
        ></el-input>
      </div>

      <div class="submit">
        <button @click="SubmitResetPassword">确认修改</button>
        <p
          style="text-decoration: underline"
          @click=";(isLogin = true), (isReset = false)"
        >
          返回登录
        </p>
      </div>
    </div>

    <div class="register" v-else-if="isLogin == false">
      <div class="re-user">
        <el-input
          placeholder="请输入用户名"
          v-model="relogin.reUser"
          clearable
          prefix-icon="el-icon-user"
        ></el-input>
      </div>
      <div class="re-phone">
        <el-input
          placeholder="请输入手机号"
          v-model="relogin.rePhone"
          clearable
          prefix-icon="el-icon-phone"
          @blur="LoseBlur(relogin.rePhone)"
        ></el-input>
      </div>
      <div class="re-pas">
        <el-input
          placeholder="请输入密码"
          v-model="relogin.rePas"
          clearable
          prefix-icon="el-icon-lock"
          show-password
        ></el-input>
      </div>
      <div class="re-idcard">
        <el-input
          placeholder="请输入身份证号"
          v-model="relogin.reIdcard"
          clearable
          prefix-icon="el-icon-postcard"
          @blur="LoseIdBlur(relogin.reIdcard)"
        ></el-input>
      </div>
      <div class="body">
        <span>您注册的身份:</span>
        <el-radio
          v-model="relogin.radio"
          label="0"
          @change="relogin.masses = 'false'"
          >群众</el-radio
        >
        <el-radio
          v-model="relogin.radio"
          label="1"
          @change="relogin.masses = 'true'"
          >东坡党员</el-radio
        >
        <el-radio
          v-model="relogin.radio"
          label="2"
          @change="relogin.masses = 'false'"
          >非东坡党员</el-radio
        >
      </div>
      <div class="other-msg">
        <div class="real-name">
          <span>真实姓名:</span>
          <el-input
            placeholder="请输入"
            v-model="relogin.realName"
            clearable
          ></el-input>
        </div>
        <div class="place" v-show="relogin.radio != 2">
          <span>所在村/社区：</span>
          <el-select
            v-model="towns.value"
            placeholder="选择乡/镇"
            @visible-change="town"
            @change="temp"
          >
            <el-option
              v-for="item in towns.datas"
              :key="item.value"
              :label="item.TownShip1"
              :value="item.TownShip1"
            ></el-option>
          </el-select>
        </div>
        <div class="place-tow" v-show="relogin.radio != 2">
          <span></span>
          <el-select
            v-model="villages.value"
            placeholder="选择村/社区"
            @visible-change="village"
          >
            <el-option
              v-for="item in villages.datas"
              :key="item.id"
              :label="item.Town"
              :value="item.Town"
            ></el-option>
          </el-select>
        </div>
        <div class="real-name" v-show="relogin.radio == 2">
          <span>所属的党支部:</span>
          <el-input
            placeholder="请输入党支部名称"
            v-model="notParty"
            clearable
          ></el-input>
        </div>

        <div class="party" v-if="relogin.masses == 'true' ? true : false">
          <span>选择党支部</span>
          <chooseParty @change-party="changeParty"></chooseParty>
        </div>
      </div>
      <div class="submit">
        <button @click="registerRe">立即注册</button>
        <p style="text-decoration: underline" @click="toggle">
          已有账号 去登陆
        </p>
      </div>
    </div>

    <div class="addtion-msg">
      <a href="https://beian.miit.gov.cn">备案号：蜀ICP备18002263号-1</a>
      <p>版权所有：成都集思创科技有限公司</p>
      <div class="emblem">
        <img class="emblem-img" :src="require('@/assets/emblem.png')" alt="" />
        <p class="emblem-text">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004554&token=15eccb6f-b9c0-4927-b0d7-445f0ca763b8">
            公安备案号: 51019002004554号
          </a>
        </p>
      </div>
      <p class="version">版本: {{ version }}</p>
    </div>
    <div v-if="timeClose" class="cover-swiper" @click="dump">
      <p class="cover-text" @click="dump">点击跳过倒计时 {{ second }} s</p>
      <el-carousel height="100%" indicator-position="none" arrow="never" :interval="2000">
        <el-carousel-item v-for="(v, i) in coverSwiperImgs" :key="`swiper-item-${i}`">
          <div class="carousel-box">
            <img class="cover-img" :src="imgPath(v.pictureUrl)" alt="">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="motai" v-if="motaiShow">
      <div class="amend-passd">
        <div class="amend-passd-first">
          <p>提示：</p>
          <!-- <i class="el-icon-close"></i> -->
        </div>
        <div class="amend-passd-second">
          <p>为保障账号安全，请修改默认密码后登录。</p>
        </div>
        <div class="amend-passd-third">
          <el-input
            placeholder="请输入密码"
            v-model="amend.pas1"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
          <el-input
            placeholder="请确认密码"
            v-model="amend.pas2"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </div>
        <div class="amend-passd-four">
          <el-button @click="motaiShow = false">取消</el-button>
          <el-button type="primary" @click="FamendPas">确认</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chooseParty from './component/chooseParty.vue'

import { getCover } from '@/api/common'
import { loginApi, updPwdApi } from '@/api/index'

import { imgPath, setCookie, getCookie, aesDecrypt, aesEncrypt } from '@/utils/common.js'
import { phoneReg, userPassReg, IDcardReg } from '@/utils/regexp.js'
import defaultSettings from '@/setting.js'

const Base64 = require('js-base64').Base64

export default {
  components: { chooseParty },
  data() {
    return {
      version: defaultSettings.version,
      login: {
        user: '',
        pas: '',
        checked: false,
      },
      isLogin: true,
      relogin: {
        rePhone: '',
        rePas: '',
        reIdcard: '',
        radio: '0',
        reUser: '',
        realName: '',
        masses: 'false',
      },
      options: [],
      value: [],
      towns: {
        value: '',
        datas: [],
      },
      villages: {
        value: '',
        datas: [],
      },
      temps: '',
      partyTemps: '',
      timeClose: false,
      second: 5,
      coverSwiperImgs: [],
      notParty: '', //选择非东坡党组织时，需要填写的党组织名称
      amend: {
        pas1: '',
        pas2: '',
      },
      defaultPasC1id: 0, // 修改默认密码 用户id
      motaiShow: false,
      resetPassword: {
        //重置密码
        userName: '',
        idCard: '',
        phone: '',
        rePas: '',
        twoRePas: '',
      },
      isReset: false,
      perfectCode: 5,
    }
  },
  mounted: function() {
    this.close()
    this.judgeHasAccount()
    // let list = document.cookie.split(';')
    // console.log('cookie', list)
    // for (let x in list) {
    //   if (list[x].indexOf('dpUserName') > -1) {
    //     this.login.user = list[x].split('=')[1]
    //     this.login.checked = true
    //   }
    // }
  },
  created() {
    this.thanTime()
    sessionStorage.clear()

    // sessionStorage.removeItem('c2token')
    // sessionStorage.removeItem('c2userid')
    // sessionStorage.removeItem('statuCode')
    // sessionStorage.removeItem('c1roleid')
    this.perfectCode = Number(this.$route.query?.code || 5)
  },
  methods: {
    imgPath,
    judgeHasAccount() {
      const loginPhone = getCookie('loginPhone') || ''
      const password = getCookie('password') ? Base64.decode(getCookie('password')) : ''
      if (loginPhone) {
        this.login.user = loginPhone
        this.login.pas = password
        this.login.checked = true
      }
    },
    handleIsRememberPwd() {
      if (this.login.checked) {
        setCookie('loginPhone', this.login.user)
        const password = Base64.encode(this.login.pas)
        setCookie('password', password)
      } else {
        setCookie('loginPhone', '')
        setCookie('password', '')
      }
    },
    // 封面图
    thanTime() {
      getCover().then(res => {
        if (res?.code === 0) {
          this.coverSwiperImgs = res.msg || []
          this.timeClose = true
          //获取当前时间
          // function FormatDate() {
          //   var now = new Date()
          //   var year = now.getFullYear()
          //   var month = now.getMonth()
          //   var date = now.getDate()
          //   month = month + 1
          //   if (month < 10) {
          //     month = '0' + month
          //   }
          //   if (date < 10) {
          //     date = '0' + date
          //   }
          //   var time = year + '-' + month + '-' + date
          //   return time
          // }
          // var today_time = FormatDate()
          // if (today_time >= '2022-06-03' && today_time <= '2022-06-05') {
          //   this.timeClose = true
          // }
        }
      })
    },
    dump() {
      this.timeClose = false
    },
    close() {
      let x = this.second
      let interval = setInterval(() => {
        x--
        this.second = x
        if (this.second <= 0) {
          this.timeClose = false
          clearInterval(interval)
        }
      }, 1000)
    },

    toggle() {
      return (this.isLogin = !this.isLogin)
    },
    loginClick() {
      const { user, pas } = this.login
      if (!user || !pas) {
        this.$message.warning({ message: '请填写用户名及密码', duration: 2000 })
        return
      }
      if (!phoneReg(user)) {
        this.$message.warning({ message: '手机号格式有误', duration: 2000 })
        return
      }
      if (!userPassReg(pas)) {
        this.$message.warning({ message: '密码为8-20位字符, 且包含数字、字母、特殊符号三种组合', duration: 2000 })
        return
      }
      const params = {
        c1mobileid: aesEncrypt(user),
        c1loginpwd: aesEncrypt(pas)
      }
      if (this.perfectCode === 5 || this.perfectCode === undefined) {
        loginApi(params).then(res => {
          const { code, msg } = res
          const aesField = ['token', 'township', 'partybrach', 'name', 'loginname', 'mobileid', 'town']
            const userInfo = {}
            for (const key in msg) {
              userInfo[key] = aesField.includes(key) ? aesDecrypt(msg[key]) : msg[key]
            }
            // 记录密码以及账号
            localStorage.setItem('loginPhone', aesEncrypt(user))
            localStorage.setItem('password', aesEncrypt(pas))
            if (code === 0) {
              this.handleIsRememberPwd()
              sessionStorage.setItem('token', userInfo.token)
              sessionStorage.setItem('id', userInfo.id)
              sessionStorage.setItem('roleid', userInfo.roleid)
              localStorage.setItem('roleid', userInfo.roleid)
              sessionStorage.setItem('status', userInfo.status)
              sessionStorage.setItem('rid', userInfo.rid)
              sessionStorage.setItem('township', userInfo.township) //本来是township
              sessionStorage.setItem('partybrach', userInfo.partybrach)
              sessionStorage.setItem('imgheader', userInfo.imgheader)
              sessionStorage.setItem('mobileid', userInfo.mobileid)
              sessionStorage.setItem('name', userInfo.name)
              sessionStorage.setItem('reseauStatus', userInfo.reseauStatus)
              sessionStorage.setItem('pmbid', userInfo.pmbid)
              sessionStorage.setItem('town', userInfo.town)
              sessionStorage.setItem('statuCode', code)

              this.$router.push('index')
            }
            if (code === 1) this.$message.warning({ message: msg, duration: 2000 })
            if (code === 4) {
              this.defaultPasC1id = msg
              this.motaiShow = true
            }
            if (![0, 1, 4].includes(code)) this.$router.push('perfectMsgLogin')
        })
      } else if ([0, 1].includes(this.perfectCode)) {
        loginApi({ c2name: 'volunteer', ...params }).then(res => {
          const { code, msg, token } = res
          const aesField = ['token', 'township', 'partybrach', 'name', 'loginname', 'mobileid', 'town', 'c1name', 'c1phone', 'c2community', 'c2province', 'c2street', 'c2village']
            const userInfo = {}
            for (const key in msg) {
              userInfo[key] = aesField.includes(key) ? aesDecrypt(msg[key]) : msg[key]
            }

            if (code == 0) {
              // document.cookie = this.login.checked ? `dpUserName=${this.login.user}; dpPwd=${this.login.pas}` : ''
              this.handleIsRememberPwd()
              sessionStorage.setItem('token', userInfo.token)
              sessionStorage.setItem('id', userInfo.id)
              sessionStorage.setItem('roleid', userInfo.roleid)
              sessionStorage.setItem('status', userInfo.status)
              sessionStorage.setItem('rid', userInfo.rid)
              sessionStorage.setItem('township', userInfo.township) //本来是township
              sessionStorage.setItem('partybrach', userInfo.partybrach)
              sessionStorage.setItem('imgheader', userInfo.imgheader)
              sessionStorage.setItem('mobileid', userInfo.mobileid)
              sessionStorage.setItem('name', userInfo.name)
              sessionStorage.setItem('reseauStatus', userInfo.reseauStatus)
              sessionStorage.setItem('pmbid', userInfo.pmbid)
              sessionStorage.setItem('town', userInfo.town)
              sessionStorage.setItem('statuCode', code)

              this.$router.push('index')
            }
            if (code === 2) {
              this.$store.commit('perfectUserMsgs', userInfo)
              sessionStorage.setItem('c2userid', userInfo.c2userid)
              sessionStorage.setItem('c1roleid', userInfo.c1roleid || 0)
              sessionStorage.setItem('c2token', aesDecrypt(token))
              this.$router.push({ path: '/partyReport', query: { title: '东坡志愿服务活动' }})
            }
            if (code === 4) {
              this.defaultPasC1id = msg
              this.motaiShow = true
            }
            if (![0, 2, 4].includes(code)) this.$router.push({ path: 'perfectMsgLogin' })
        })
      }
    },
    tourist() {
      this.axios
        .get('/api/Login/NoLogin')
        .then((e) => {
          if (e.data.code == 0) {
            sessionStorage.setItem('token', e.data.msg.token)
            sessionStorage.setItem('id', e.data.msg.id)
            sessionStorage.setItem('roleid', e.data.msg.roleid)
            sessionStorage.setItem('status', e.data.msg.status)
            sessionStorage.setItem('rid', e.data.msg.rid)
            sessionStorage.setItem('township', e.data.msg.township)
            sessionStorage.setItem('partybrach', e.data.msg.partybrach)
            sessionStorage.setItem('imgheader', e.data.msg.imgheader)
            sessionStorage.setItem('name', e.data.msg.name)
            this.$router.push('index')
          }
        })
    },
    temp(e) {
      this.temps = e
      this.villages.value = ''
      this.villages.data = []
    },
    town(e) {
      if (e) {
        this.axios
          .get('/api/Login/Township')
          .then((e) => {
            if (e.data.code == 0) {
              this.towns.datas = e.data.msg
            }
          })
      }
    },
    village(e) {
      if (e) {
        this.axios
          .get(`/api/Login/Village?township=${this.temps}`)
          .then((e) => {
            if (e.data.code == 0) {
              this.villages.datas = e.data.msg
            }
          })
      }
    },

    LoseBlur(value) {
      if (value == '') return
      if (!/^1[3456789]\d{9}$/.test(value)) {
        alert('手机号码有误，请重填')
        this.relogin.rePhone = ''
        this.resetPassword.phone = ''
      }
    },
    LoseIdBlur(value) {
      if (value == '') return
      if (!IDcardReg(value)) {
        alert('身份证号码有误，请重填')
        this.relogin.reIdcard = ''
        this.resetPassword.idCard = ''
      }
    },
    changeParty(e) {
      this.partyTemps = e
    },
    registerRe() {
      let list = Object.keys(this.relogin)
      for (let x in list) {
        if (this.relogin[list[x]] == '') {
          alert('请填写完整')
          return
        }
      }
      if (this.relogin.radio != '2') {
        if (this.towns.value == '' || this.villages.value == '') {
          alert('请填写乡镇/社区！')
          return
        }
      }
      if (this.relogin.radio == '2' && this.notParty == '') {
        alert('请填写所属党支部！')
        return false
      }
      let data = {}
      if (this.relogin.radio == '0') {
        data = {
          c1loginname: this.relogin.reUser,
          c1mobileid: this.relogin.rePhone,
          c1loginpwd: this.relogin.rePas,
          c1pid: this.relogin.reIdcard,
          c2name: this.relogin.realName,
          c2township: this.towns.value,
          c2town: this.villages.value,
          c2status: this.relogin.radio * 1,
        }
      } else if (this.relogin.radio == '2') {
        data = {
          c1loginname: this.relogin.reUser,
          c1mobileid: this.relogin.rePhone,
          c1loginpwd: this.relogin.rePas,
          c1pid: this.relogin.reIdcard,
          c2name: this.relogin.realName,
          c2status: this.relogin.radio * 1,
          c2partybrach: this.notParty,
        }
      } else {
        let tier = 0
        let end = () => {
          for (let x = this.partyTemps.length - 1; x >= 0; x--) {
            if (this.partyTemps[x].value != '') {
              tier = x + 1
              return this.partyTemps[x]
            }
          }
        }
        data = {
          c1mobileid: this.relogin.rePhone,
          c1loginname: this.relogin.reUser,
          c1loginpwd: this.relogin.rePas,
          c1pid: this.relogin.reIdcard,
          c2name: this.relogin.realName,
          c2township: this.towns.value,
          c2town: this.villages.value,
          c2status: this.relogin.radio * 1,
          c2fid: this.partyTemps[0].value,
          c2fname: this.partyTemps[0].name,
          c2pmbid: end().value,
          c2partybrach: end().name,
          c2tid: tier,
        }
      }

      if (!userPassReg(data.c1loginpwd)) {
        this.$message({
          message: '请输入8-20位字符，须包含数字、大小写字母、特殊符号三种组合。',
          type: 'error',
          offset: 300,
        })
        return
      }
      this.axios.post('/api/Login/register', data).then((e) => {
        if (e.data.code == 0) {
          this.$message({
            message: '注册成功,等待管理人员审核',
            type: 'error',
            offset: 300,
          })
        } else alert(e.data.msg)
      })
    },
    FamendPas() {
      const { pas1, pas2 } = this.amend
      if (!pas1 || !pas2) {
        this.$message.warning({ message: '请填写完整' })
        return
      }
      if (!userPassReg(pas1) || !userPassReg(pas2)) {
        this.$message.warning({ message: '密码为8-20位字符, 且包含数字、字母、特殊符号三种组合' })
        return
      }
      if (pas1 !== pas2) {
        this.$message.warning({ message: '两次密码不一致' })
        return
      }
      const params = {
        c1loginpwd: aesEncrypt(pas1),
        c1id: this.defaultPasC1id
      }
      updPwdApi(params).then(res => {
        if (res.code === 0) {
          this.login.pas = ''
          setCookie('loginPhone', this.login.user)
          setCookie('password', '')
          this.$message.success({ message: '修改成功，请重新登录' })
          this.motaiShow = false
        } else this.$message.warning(res.msg)
      })
    },
    SubmitResetPassword() {
      //重置密码
      for (let key in this.resetPassword) {
        if (this.resetPassword[key] == '') {
          this.$message({
            message: '请填写完整',
            type: 'error',
            offset: 300,
          })
          return false
        }
      }
      if (this.resetPassword.rePas != this.resetPassword.twoRePas) {
        this.$message({
          message: '两次密码输入不一致！',
          type: 'error',
          offset: 300,
        })
        return false
      }
      if (!userPassReg(this.resetPassword.rePas)) {
        this.$message({
          message: '请输入8-20位字符，须包含数字、大小写字母、特殊符号三种组合。',
          type: 'error',
          offset: 300,
        })
        return false
      }

      console.log(this.resetPassword)
      let data = {
        c1pid: this.resetPassword.idCard,
        c2name: this.resetPassword.userName,
        c1mobileid: this.resetPassword.phone,
        c1loginpwd: aesEncrypt(this.resetPassword.rePas),
      }
      this.axios({
        url: '/api/Login/UpdPassword',
        method: 'post',
        data,
      }).then((res) => {
        switch (res.data.code) {
          case 0:
            this.$message({
              message: '修改成功，请登录!',
              type: 'success',
              offset: 300,
            })
            this.isLogin = true
            this.isReset = false
            break
          case 2:
            this.$message({
              message: '真实姓名、身份证号码或手机号输入有误!',
              type: 'error',
              offset: 300,
            })
            break
          default:
            this.$message({
              message: '修改失败！',
              type: 'error',
              offset: 300,
            })
        }
        for (let key in this.resetPassword) {
          this.resetPassword[key] = ''
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.motai {
  .amend-passd {
    &-four {
      margin-top: 0.2rem;
      text-align: right;
    }
    &-third {
      .el-input {
        margin-top: 0.2rem;
      }
      line-height: 2;
    }
    &-second {
      margin-top: 0.2rem;
      color: #666666;
    }
    &-first {
      p {
        font-size: 0.36rem;
        color: #999999;
      }
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    width: 80%;
    margin: 0 auto;
    margin-top: 4rem;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.2rem;
  }
  width: 100%;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.2);
  position: fixed;
  top: 0;
  z-index: 11;
}
</style>

<style lang="scss" scoped>
.register {
  /deep/.el-radio__label {
    padding-left: 0.1rem;
  }
  /deep/.el-radio {
    margin-right: 0.15rem;
  }
}
</style>

<style lang="scss">
.logins {
  font-size: 0.3rem;
  min-height: 100vh;
  padding-bottom: 0.4rem;
  background: url('../assets/login/login-bg.webp') center no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .platform_title {
    width: 6.4rem;
  }
  .addtion-msg {
    a {
      color: #fff;
    }
    margin-top: 0.2rem;
    color: #fff;
    font-size: 0.25rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .emblem {
      display: flex;
      align-items: center;
      margin-top: 0.08rem;
      .emblem-img {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
    .version {
      margin-top: 0.1rem;
    }
  }
  .cover-swiper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    .cover-text {
      position: absolute;
      top: 0.4rem;
      right: 0.4rem;
      font-size: 0.3rem;
      background: rgba($color: #000, $alpha: 0.3);
      color: #fff;
      line-height: 2;
      padding: 0 0.1rem;
      z-index: 1001;
    }
    .carousel-box {
      width: 100%;
      height: 100%;
      .cover-img {
        width: 100%;
        height: 100%;
      }
    }
    .el-carousel {
      width: 100%;
      height: 100% !important;
    }
  }
  .register {
    .re-user,
    .re-phone,
    .re-pas,
    .re-idcard {
      margin-bottom: 0.3rem;
    }
    .submit {
      p {
        padding: 0.5rem 0;
        color: #fff;
      }
      button {
        width: 100%;
        height: 0.86rem;
        border-radius: 0.43rem;
        border: solid 0.02rem #ffffff;
        background: none;
        color: #fff;
        outline: none;
        font-size: 0.34rem;
      }
      text-align: center;
      margin-top: 0.5rem;
    }
    .other-msg {
      font-size: 0.26rem;
      .party1,
      .party2,
      .party3,
      .place-tow,
      .party,
      .place {
        display: flex;

        color: #fff;
        align-items: center;
        span {
          display: inline-block;
          width: 30%;
          margin-left: 0.2rem;
        }
        .el-select {
          input {
            border: none;
            border-bottom: 0.01rem solid #fff;
            border-radius: 0;
            &::-webkit-input-placeholder {
              color: #fff;
            }
          }
        }
      }
      .real-name {
        display: flex;
        color: #fff;
        align-items: center;
        span {
          display: inline-block;
          width: 30%;
          margin-left: 0.2rem;
        }
        .el-input {
          width: 60%;
          input {
            border: none;
            border-bottom: 0.01rem solid #fff;
            border-radius: 0;
            &::-webkit-input-placeholder {
              color: #fff;
            }
          }
        }
      }
      margin-top: 0.3rem;
      padding-bottom: 0.3rem;
      background: rgba($color: #fff, $alpha: 0.2);
    }
    .body {
      color: #fff;
      .el-radio {
        color: #fff;
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: #fff;
      }
    }
    width: 89%;
    margin: 0 auto;
    margin-top: 0.5rem;
    input {
      background: none;
      color: #fff;
    }
  }
  .login {
    width: 80%;
    margin: 0 auto;
    margin-top: 1rem;
    .submit {
      text-align: center;
      margin-top: 1rem;
      p {
        margin-top: 0.5rem;
        color: #fff;
      }
      button {
        width: 100%;
        height: 0.86rem;
        border-radius: 0.43rem;
        border: solid 0.02rem #ffffff;
        background: none;
        color: #fff;
        outline: none;
        font-size: 0.34rem;
      }
    }
    .remeber {
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #fff;
      }
      .el-checkbox {
        font-size: 0.3rem;
        color: #fff;
      }
      font-size: 0.26rem;
    }

    .el-input__icon {
      height: 0;
    }
    input {
      background: none;
      color: #fff;
      margin-bottom: 0.3rem;
    }
  }
  .dump-login {
    color: #fff;
    line-height: 2;
    margin-left: 75%;
    padding-top: 0.4rem;
  }
  .el-input__prefix {
    top: 2%;
  }
  .el-input {
    input {
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
  }
}
</style>
